import styles from "../../styles/Footer.module.scss";

export default () => {
  return (
    <footer className={ styles.footer }>
      &copy; 2023 Alex Schneider
    </footer>
  );
}